import {createStore} from 'vuex'

import leads from '@/store/leads'
import account from '@/store/account'


export default createStore({
  modules: { leads, account },
  state: {
    isFetching: false,
    isLoadedFilters: false,
    isMobileVersion: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    showAll: false
  },
  mutations: {
    CHANGE_FETCHING(state, payload) {
      state.isFetching = payload
    },
    LOAD_FILTERS(state, payload) {
      state.isLoadedFilters = payload
    },
    TOGGLE_FIELDS_VISIBILITY(state) {
      state.showAll = !state.showAll
    }
  },
  getters: {
    isFetching(state) {
      return state.isFetching
    },
    isLoadedFilters(state) {
      return state.isLoadedFilters
    },
    isMobileVersion(state) {
      return state.isMobileVersion
    },
    showAll(state) {
      return state.showAll
    }
  }
})
